import moment from 'moment';
import { useMemo } from 'react';
import { CalculateDaysBetweenDates } from '../../../../helpers/Custom';
import { SystemDetail } from '../../../../models/ApiModels';

interface Props {
  system: SystemDetail;
}
const FunctionTrialsBanner = ({ system }: Props) => {
  const trialDaysLeftUntilExpiration = useMemo(() => {
    if (system.trialExpirationDate) {
      return CalculateDaysBetweenDates(new Date(), system.trialExpirationDate);
    }
    return null;
  }, [system.trialExpirationDate]);

  const daysBetweenLicenseAndTrial = useMemo(() => {
    if (system.licenseInstalledDate && system.trialExpirationDate) {
      return CalculateDaysBetweenDates(system.licenseInstalledDate, system.trialExpirationDate);
    }
    return null;
  }, [system.licenseInstalledDate, system.trialExpirationDate]);
  const handleFunctionColor = () => {
    if (daysBetweenLicenseAndTrial && trialDaysLeftUntilExpiration) {
      if (trialDaysLeftUntilExpiration > 10) {
        return 'bg-[#E29FE3]';
      } else if (trialDaysLeftUntilExpiration > 5) {
        return 'bg-warning-100';
      } else if (trialDaysLeftUntilExpiration > 0) {
        return 'bg-error-100';
      } else {
        return 'bg-gray-5';
      }
    }
  };

  const handleFunctionStatus = (status: string, trialDaysLeftUntilExpiration: number | null) => {
    if (status === 'PendingLicense') {
      return 'Waiting for installation.';
    } else if (trialDaysLeftUntilExpiration && trialDaysLeftUntilExpiration >= 0) {
      return trialDaysLeftUntilExpiration + ' days left';
    } else {
      return 'Trial expired';
    }
  };

  const daysLeftBar =
    trialDaysLeftUntilExpiration && daysBetweenLicenseAndTrial
      ? Math.min((trialDaysLeftUntilExpiration / daysBetweenLicenseAndTrial) * 100, 100)
      : 0;

  return (
    <>
      <div className='lg:mt-11 xl:mt-0'>
        <h4 className='prose-heading4'>Function trial</h4>
        <p className='prose-paragraphSmaller border-b border-gray-10 pb-2'>
          This system is having a temporary Ultimate license. After the trial, the system will reset to the functions it
          had before.
        </p>
        <div className={`relative w-full ${system.status === 'PendingLicense' ? 'bg-error-50' : 'bg-gray-5'}`}>
          <span className='absolute right-2 top-1/2 -translate-y-1/2 opacity-50 prose-labelPill'>
            {handleFunctionStatus(system.status, trialDaysLeftUntilExpiration)}{' '}
            {system.trialExpirationDate && moment(system.trialExpirationDate).format('YYYY-MM-DD')}
          </span>
          <div style={{ width: daysLeftBar + '%' }} className={` ${handleFunctionColor()} w-full h-10  p-2 mt-5`}></div>
        </div>
      </div>
    </>
  );
};

export default FunctionTrialsBanner;
